import React, { Component } from 'react'

import { BankAccount } from '../../../core/types'
import { Task } from '../types'
import { displayDollars } from '../../../helpers/displayFormatHelper'

export interface Props {
  task: Task
}

export default class VerifyFunds extends Component<Props> {
  render() {
    const { task } = this.props
    const { amount, downPayment, type } = task.entity
    const { bankName, accountNumber, routingNumber } = task
      .verifiables[0] as BankAccount

    const paymentLabel = () => {
      if (type === 'CASH') {
        return 'Cash offer amount'
      } else if (type === 'FINANCED') {
        return 'Down payment amount'
      } else {
        return 'Amount'
      }
    }

    const paymentAmount = () => {
      if (type === 'CASH') {
        return displayDollars(amount)
      } else if (type === 'FINANCED') {
        return displayDollars(downPayment)
      }
    }
    return (
      <div className="task-bodies__verify-funds">
        <div className="task-bodies__verify-funds__header">
          <h1>{bankName}</h1>
        </div>
        <div className="task-bodies__verify-funds__body">
          <div className="task-bodies__verify-funds__body-left">
            <div className="task-bodies__verify-funds__body-left--row">
              Routing #
            </div>
            <div className="task-bodies__verify-funds__body-left--row">
              Account #
            </div>
            {task.entityType === 'OFFER' ? (
              <div className="task-bodies__verify-funds__body-left--row">
                {paymentLabel()}
              </div>
            ) : null}
          </div>
          <div className="task-bodies__verify-funds__body-right">
            <div className="task-bodies__verify-funds__body-right--row">
              {routingNumber ? routingNumber : null}
            </div>
            <div className="task-bodies__verify-funds__body-right--row">
              {accountNumber ? accountNumber : null}
            </div>
            {task.entityType === 'OFFER' ? (
              <div className="task-bodies__verify-funds__body-right--row">
                {paymentAmount()}
              </div>
            ) : null}
          </div>
        </div>
        <div className="task-bodies__verify-funds__body-right" />
      </div>
    )
  }
}
